import { ModuleFE_BaseDB } from '@nu-art/thunderstorm-frontend/index';
import { ModuleSyncType } from '@nu-art/thunderstorm-frontend/modules/db-api-gen/types';
export const AdvisorStaticIDBGroup = 'advisor-static';
export class ModuleFE_AdvisorStatic extends ModuleFE_BaseDB {
    constructor(dbDef, defaultDispatcher) {
        const _dbDef = { ...dbDef, frontend: { ...dbDef.frontend } };
        _dbDef.frontend.group = AdvisorStaticIDBGroup;
        super(_dbDef, defaultDispatcher, ModuleSyncType.CSVSync);
        this.logInfo(`Constructor of static DB module '${dbDef.dbKey}'`);
    }
}
//# sourceMappingURL=ModuleFE_AdvisorStatic.js.map